import AppStatus, { IAppStatus } from "@/constants/AppStatus";

export const HEADER_CSRF_TOKEN_NAME = "X-XSRF-TOKEN";
export const X_CSRF_TOKEN = "KS4xvfRtjdK75TGPxR6FLLz6SWw6WXsJ";

export class APIError extends Error {
  constructor(public type: IAppStatus, public message: string) {
    super(message);
  }
}

const wrap = <T>(task: Promise<Response>): Promise<T> => {
  return new Promise((resolve, reject) => {
    task
      .then(response => {
        const { status } = response;
        if (status === 200) {
          response
            .json()
            .then(json => {
              resolve(json);
            })
            .catch(() => {
              resolve({} as T);
            });
        } else if (status === 204) {
          reject(new APIError(AppStatus.NO_CONTENT, "FetchAPI NO_CONTENT"));
        } else {
          response
            .json()
            .then(json => {
              reject(json);
            })
            .catch(() => {
              reject(new APIError(AppStatus.UNKNOWN_ERROR, "FetchAPI UNKNOWN_ERROR"));
            });
        }
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const cookies = (): Map<string, string> => {
  return document.cookie
    .split(";")
    .map(cookie => cookie.split("="))
    .reduce((map, current) => map.set((current[0] || "").trim(), (current[1] || "").trim()), new Map());
};

const callApi = <T>(...args: Parameters<typeof fetch>): Promise<T> => {
  const [requestInfo, requestInit] = args;
  const cookie = cookies();
  const settings = {
    ...requestInit,
    headers: {
      "X-XSRF-TOKEN": cookie.get("XSRF-TOKEN"),
    },
  } as RequestInit;
  return wrap<T>(fetch(requestInfo, settings));
};

export const getApi = <T>(...args: Parameters<typeof fetch>): Promise<T> => {
  const [requestInfo, requestInit] = args;
  return wrap<T>(fetch(requestInfo, requestInit));
};

export const postApi = <T>(...args: Parameters<typeof fetch>): Promise<T> => {
  const [requestInfo, requestInit] = args;
  const cookie = cookies();
  const settings = {
    ...requestInit,
    method: "POST",
    headers: {
      "X-XSRF-TOKEN": cookie.get("XSRF-TOKEN"),
      "Content-Type": "application/json; charset=utf-8",
    },
  } as RequestInit;
  return wrap<T>(fetch(requestInfo, settings));
};

export default callApi;
